import sinaImage from "../../assets/images/team/sina-besharat.jpg";
import rezaImage from "../../assets/images/team/reza-hasannia.jpg";
import vahidImage from "../../assets/images/team/Vahid-Rezaverdi-Nejad2.jpg";
import kamranImage from "../../assets/images/team/Kamran-Zeynalzade.jpg";
import farmLeaf2Icon from "../../assets/icons/farmLeaf3.jpeg";
const teamMembers = [
  { name: "Sina Besharat", role: "CEO", image: sinaImage },
  { name: "Reza Dalir Hasanya", role: "COO", image: rezaImage },
  { name: "Vahid Reza Verdinejad", role: "CTO", image: vahidImage },
  { name: "Kamran Zeynalzade", role: "CTO", image: kamranImage },
];
export default function Team() {
  return (
    <section
      id="Team"
      className="bg-white py-24 sm:py-32 mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8"
    >
      <div className="mx-auto w-full px-2 lg:px-8">
        {/* Section Header */}
        <div className="mx-auto max-w-2xl text-center">
          {/* Title */}
          <div className="mb-4 flex items-center justify-center gap-2">
            <h2 className="flex items-center justify-center gap-2 text-2xl font-bold tracking-tight text-primaryDark sm:text-3xl lg:text-4xl">
              <img
                src={farmLeaf2Icon}
                alt="Farm leaf icon"
                className="h-14 w-12 rounded-full"
              />
              FARM Team
            </h2>
          </div>
          {/* Description */}
          <p className="mt-6 text-lg leading-8 text-gray-600 sm:text-xl">
            A passionate team working together to build smarter, more
            sustainable, and technology-driven agriculture.
          </p>
        </div>
        {/* Team Grid */}
        <div className=" mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-x-10 gap-y-16 sm:grid-cols-2 lg:mt-20 lg:gap-x-14 lg:gap-y-20 ">
          {teamMembers.map((member) => (
            <article
              key={member.name}
              className=" group mx-auto w-full max-w-[25rem] cursor-pointer text-center transition-all duration-500 ease-out hover:-translate-y-3 "
            >
              {/* Image Container */}
              <div className=" relative w-full overflow-hidden rounded-2xl bg-gray-100 shadow-md ring-1 ring-black/5 transition-all duration-500 ease-out group-hover:shadow-2xl group-hover:ring-green-600/30 ">
                {/* Image */}
                <img
                  src={member.image}
                  rel="noreferrer"
                  alt={member.name}
                  draggable="false"
                  className=" block aspect-[4/5] h-auto w-full object-cover transition-all duration-700 ease-out group-hover:scale-110 "
                />
                {/* Dark / Green Overlay */}
                <div className=" pointer-events-none absolute inset-0 bg-gradient-to-t from-green-950/50 via-green-900/0 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100 " />
                {/* Hover Border */}
                <div className=" pointer-events-none absolute inset-0 rounded-2xl border-2 border-transparent transition-all duration-500 group-hover:border-green-500/40 " />
              </div>
              {/* Member Info */}
              <div className="mt-6">
                {/* Name */}
                <h3 className=" text-xl font-bold tracking-tight text-primaryDark transition-all duration-300 group-hover:text-green-700 group-hover:tracking-wide ">
                  {member.name}
                </h3>
                {/* Role */}
                <p className=" mt-2 text-base font-semibold uppercase text-gray-900 transition-all duration-300 group-hover:text-green-700 ">
                  {member.role}
                </p>
                {/* Decorative Line */}
                <div className=" mx-auto mt-3 h-0.5 w-0 rounded-full bg-green-600 transition-all duration-500 group-hover:w-10 " />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
